import gql from "graphql-tag";
import ATTENDANCE_FRAGMENT from "@/graphql/fragments/attendance";

export default gql`
  query getAttendance($attendanceId: ID!) {
    attendance(attendanceId: $attendanceId) {
      ...attendanceParts
    }
  }
  ${ATTENDANCE_FRAGMENT}
`;
